import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import * as _ from 'lodash';

import { FidelidadeService } from './../../_services/fidelidade.service';
import { TipoBeneficio } from './../../_models/Enums/tipoExperiencia';
import * as alerts from '../../_functions/alerts';
import { Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-beneficios',
  templateUrl: './beneficios.component.html',
  styleUrls: ['./beneficios.component.scss'],
})
export class BeneficiosComponent implements OnInit {
  public pesquisaForm: UntypedFormGroup;
  public tituloAcordeon: string = '';

  public tituloModal: string = '';
  public textoModal: string = '';
  public messageDisabled: string = 'Este benefício';

  public modalLocalizacao: boolean = false;
  public idBeneficio: number = 0;
  public countBeneficios: number = null;
  public nivelMembro: number = 0;

  public cupom: string = '';
  public textoCupom: string = '';
  public linkExterno: string = '';

  /* objetos*/
  public beneficios: any[] = [];
  public beneficiosSemFiltro: any[] = [];
  public membro: any = null;
  public beneficio: any = null;
  public beneficioDetalhe: any = null;
  public regrasGerais: string = null;
  /* variaveis de load */
  public carregandoBeneficios: boolean = false;
  public carregandoBeneficioDetalhe: boolean = false;
  public carregandoResgate: boolean = false;
  public loadingAplicar: boolean = false;
  /* variaveis de controle de exibição*/
  public exibirPopup: boolean = false;
  public btnBeneficioDisponivel: boolean = false;
  public showPopupMsgGenerica: boolean = false;
  public buttonFiltrar: boolean = false;
  public exibirPopupFiltro: boolean = false;
  // Filtros
  public niveisLista: any[] = [];
  public categoriasLista: any[] = [];

  private readonly TIPOS_EXPERIENCIA: any = `[${TipoBeneficio.Beneficio}]`;

  constructor(
    private fidelidadeService: FidelidadeService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService
  ) {
    this.pesquisaForm = this.fb.group({
      textoPesquisa: '',
    });
  }

  ngOnInit(): void {
    this.obterRegrasGerais();
    this.obterMembro();
    this.tamanhoTituloAcordeon();
    this.obterNiveisListados();
    //this.obterCategoriasListados();
  }

  tamanhoTituloAcordeon() {
    const tamanhoTela = window.innerWidth;
    tamanhoTela <= 600
      ? (this.tituloAcordeon = 'normal')
      : (this.tituloAcordeon = 'grande');
  }

  obterMembro() {
    this.membro = this.authService.LocalStorage.obterMembro();
    if (this.membro.tipoStatus === 7 || this.membro.tipoStatus === 11) {
       this.router.navigate(['/meusdados']);
    }
    this.nivelMembro = this.membro.idNivel;
    this.obterBeneficios();
  }

  obterBeneficios() {
    this.showPesquisandoBeneficios(true);
    this.fidelidadeService
      .obterExperienciasPorPaginaETipos('', `[${TipoBeneficio.Beneficio}]`)
      .subscribe({
        next: (res: any) => {
          this.showPesquisandoBeneficios(false);
          this.beneficiosSemFiltro = this.processarSucessoObterBeneficios(
            res.resultado
          );
        },
        error: (err: any) => {
          this.showPesquisandoBeneficios(false);
          console.error('Erro ao obter beneficios', err);
        },
      });
  }

  processarSucessoObterBeneficios(beneficios: any): any {
    beneficios = this.tratarExibicaoBeneficio(beneficios);

    this.beneficios = _.orderBy(beneficios, (beneficio: any) => {
      return beneficio.ordem;
    });
    this.countBeneficios = this.beneficios.length;

    for (let i = 0; i < this.beneficios.length; i++) {
      const categoria = this.categoriasLista.find(categoria => categoria.descricao === this.beneficios[i].categoria);

      if(categoria == undefined)
      {
        var objCategoria = { descricao: this.beneficios[i].categoria, valor: this.beneficios[i].idCategoria };
        
        if (!this.categoriasLista.includes(objCategoria)) {
          this.categoriasLista.push(objCategoria);
        }
      }
    }

    return this.beneficios;
  }

  private tratarExibicaoBeneficio(experiencias: any[]): any[] {
    let output = [];

    for (let i = 0; i < experiencias.length; i++) {
      const experiencia = experiencias[i];

      if (experiencia.exibirSomenteParaNivel) {
        if (!experiencia.experienciaNiveis.find(x => x.idNivel == this.nivelMembro))
          continue;
      }

      output.push(experiencia);
    }

    return output;
  }

  processarFalhaObterBeneficios(): void {
    this.countBeneficios = 0;
    this.beneficios = [];
  }

  obterRegrasGerais() {
    this.fidelidadeService
      .obterConfiguracaoPorDescricao('Regras_Gerais_Beneficios')
      .subscribe({
        next: (res: any) => (this.regrasGerais = res.valor),
        error: (err: any) => console.error('Erro ao obter regras gerais', err),
      });
  }

  abrirPopup(beneficio: any) {
    this.exibirPopup = true;
    this.beneficio = null;
    this.beneficioDetalhe = null;

    this.showBtnBeneficioDisponivel(false);
    this.showPesquisandoBeneficioDetalhe(true);
    this.tratarCamposCupom(beneficio);

    if (beneficio.idPromocao == 0) {
      this.atribuirBeneficio(beneficio);
      this.showPesquisandoBeneficioDetalhe(false);
      return;
    }

    this.fidelidadeService.obterExperiencia(beneficio.id).subscribe({
      next: (res: any) => {
        this.atribuirBeneficio(beneficio);
        this.beneficioDetalhe = res.resultado;
        this.showPesquisandoBeneficioDetalhe(false);
        this.obterItensDaPromocao(beneficio.idPromocao);
      },
      error: (err: any) => {
        console.error('Erro ao obter detalhes da exp', err);
        this.showPesquisandoBeneficioDetalhe(false);
      },
    });
  }

  tratarCamposCupom(beneficio: any): void {
    if (beneficio.beneficioCupomPorNivel) {
      var nivelMembro = beneficio.experienciaNiveis.find((x: any) => x.idNivel == this.membro.idNivel);

      this.preencherCamposCupom(
        nivelMembro?.cupom,
        nivelMembro?.textoCupom,
        nivelMembro?.linkExterno);
    } else {
      this.preencherCamposCupom(
        beneficio.cupom,
        beneficio.textoCupom,
        beneficio.linkExterno
      );
    }

  }

  private preencherCamposCupom(cupom: string, textoCupom: string, linkExterno: string): void {
    this.cupom = cupom;
    this.textoCupom = textoCupom;
    this.linkExterno = linkExterno;
  }

  membroPertenceAoNivel(niveis: any): boolean {
    return niveis.some((x) => x.idNivel === this.membro.idNivel);
  }

  validarCondicaoResgate(): void {
    this.carregandoResgate = true;

    this.fidelidadeService
      .obterValidacoesDeCondicaoDeResgate(this.beneficio.id, this.membro.cpf)
      .subscribe({
        next: (res: any) => {
          var result = res.resultado;

          if (result.isValid) this.btnAtivarBeneficio();
          else this.mostrarMensagemNaoSatisfezCondicao(result);
        },
        error: (err: any) => {
          this.exibirPopup = false;
          this.carregandoResgate = false;

          this.tituloModal = 'Ops, algo deu errado!';
          this.textoModal =
            'Você ainda não é elegível para o resgate do benefício! Verifique as condições!';

          this.showPopupMsgGenerica = true;
        },
      });
  }

  public mostrarMensagemNaoSatisfezCondicao(res: any) {
    this.exibirPopup = false;
    this.carregandoResgate = false;

    this.tituloModal = res.tituloPopup;
    this.textoModal = res.mensagem;

    this.showPopupMsgGenerica = true;
  }

  btnAtivarBeneficio(): void {
    this.fidelidadeService
      .resgatarExperiencia(
        this.beneficioDetalhe.experienciaParceiro[0].id,
        this.membro.cpf,
        1,
        this.beneficioDetalhe.experienciaLotes[0].id,
        null,
        null
      )
      .subscribe({
        next: (res: any) => {
          this.carregandoResgate = false;

          alerts.exibirToast(
            'success',
            'Benefício ativado com sucesso',
            'top-right'
          );

          this.fidelidadeService.obterMembro().subscribe({
            next: (res: any) => this.authService.LocalStorage.salvarMembro(res)
          });
          
          this.showBtnBeneficioDisponivel(true);
        },
        error: (err: any) => {
          this.exibirPopup = false;
          this.carregandoResgate = false;
          let swalText: string = '';

          err.mensagensErro.forEach((erro: string) => {
            erro = erro.replace('Membro', 'Você');
            swalText += erro + '';
          });

          if (swalText.includes('48h')) {
            this.tituloModal = 'Hey, ainda não é o seu aniversário!';
            this.textoModal =
              'Volte 2 dias antes do seu aniversário para garantir esse presente!';
          } else {
            this.tituloModal = 'Ops, algo deu errado!';
            this.textoModal = swalText;
          }

          this.showPopupMsgGenerica = true;
        },
      });
  }

  abrirLinkExterno(link: string): void {
    window.open(`${link}`, '_blank');
  }

  aplicarFiltros(): void {
    if (this.filtrosEstaoVazios()) {
      this.exibirPopupFiltro = false;
      this.buttonFiltrar = false;
      this.beneficios = this.beneficiosSemFiltro;
      this.countBeneficios = this.beneficiosSemFiltro.length;
      return;
    }

    this.loadingAplicar = true;

    var filtroExperiencia: any = {
      tipos: this.TIPOS_EXPERIENCIA,
      niveis: this.obterFiltroNiveis(),
      estados: '',
      categorias: this.obterFiltroCategorias(),
      campanhas: '',
      ordem: '',
      descricao: this.pesquisaForm.value.textoPesquisa ?? '',
      rangeCacaus: '',
      filtraQuantidadeDisponivel: false,
    };

    this.fidelidadeService.searchExperiencias(filtroExperiencia).subscribe({
      next: (res: any) => {
        this.processarSucessoObterBeneficios(res.resultado);
        this.exibirPopupFiltro = false;
        this.loadingAplicar = false;
      },
      error: (err: any) => {
        this.loadingAplicar = false;
        this.exibirPopupFiltro = false;
        this.processarFalhaObterBeneficios();
      },
    });
  }

  private filtrosEstaoVazios(): boolean {
    const niveisFiltrados = this.niveisLista.filter(
      (x) => x.selecionado == true
    );
    const categoriasFiltrados = this.categoriasLista.filter(
      (x) => x.selecionado == true
    );
    return (
      niveisFiltrados.length == 0 &&
      categoriasFiltrados.length == 0 &&
      !this.pesquisaForm.value.textoPesquisa
    );
  }

  public desmarcarItem(item: any): void {
    item.selecionado = false;

    this.aplicarFiltros();
  }

  public obterFiltrosSelecionados(lista: any[]): any[] {
    return lista.filter((x) => x.selecionado);
  }

  private obterFiltroNiveis(): string {
    var result = '';

    const niveis = _.filter(this.niveisLista, (nivel: any) => {
      return nivel.selecionado;
    }).map((x) => x.id);

    if (niveis.length > 0) return this.obterString(niveis);

    return result;
  }

  private obterFiltroCategorias(): string {
    const categorias = _.filter(this.categoriasLista, (categoria: any) => {
      return categoria.selecionado;
    }).map((x) => x.valor);

    if (categorias.length > 0) return this.obterString(categorias);

    return '';
  }

  private obterString(lista: any): string {
    this.buttonFiltrar = true;
    return '[' + lista.join(',') + ']';
  }

  limparFiltros(): void {
    for (let nivel of this.niveisLista) nivel.selecionado = false;
    for (let categorias of this.categoriasLista) categorias.selecionado = false;

    this.beneficios = this.beneficiosSemFiltro;
    this.buttonFiltrar = false;
  }

  public obterNiveisListados() {
    this.fidelidadeService.obterNiveis().subscribe({
      next: (niveis: any) => this.tratarNiveis(niveis),
      error: (niveisErro: any) => console.log(niveisErro),
    });
  }

  public tratarNiveis(niveis: any) {
    for (let nivel of niveis) {
      nivel.selecionado = false;
    }

    niveis = _.orderBy(niveis, (nivel: any) => {
      return nivel.id;
    });

    this.niveisLista = niveis;
  }

  private obterCategoriasListados() {
    this.fidelidadeService
      .obterTiposExperiencias(
        'experiencia',
        'idCategoria',
        this.TIPOS_EXPERIENCIA
      )
      .subscribe({
        next: (categorias: any) => this.tratarCategorias(categorias),
        error: (categoriasErro: any) => console.log(categoriasErro),
      });
  }

  public tratarCategorias(res: any) {
    for (let item of res) {
      item.selecionado = false;
    }
    this.categoriasLista = res;
  }

  public selecionarNivel(index: number) {
    this.niveisLista[index].selecionado = !this.niveisLista[index].selecionado;
  }

  public selecionarCategoria(index: number) {
    this.categoriasLista[index].selecionado =
      !this.categoriasLista[index].selecionado;
  }

  private obterItensDaPromocao(idPromocao: any): void {
    this.fidelidadeService.obterPromocaoPorId(idPromocao).subscribe({
      next: (res: any) => {
        this.beneficio.promocao = res;
      },
      error: (err: any) => console.error('Erro ao obter promocao...', err),
    });
  }

  private showPesquisandoBeneficios(show: boolean) {
    this.carregandoBeneficios = show;
  }

  private showBtnBeneficioDisponivel(show: boolean) {
    this.btnBeneficioDisponivel = show;
  }

  private showPesquisandoBeneficioDetalhe(show: boolean) {
    this.carregandoBeneficioDetalhe = show;
  }

  private atribuirBeneficio(beneficio: any): void {
    this.beneficio = beneficio;
  }

  fecharPopup() {
    this.exibirPopup = false;
  }

  abrirModalLocalizacao(index: number): void {
    this.modalLocalizacao = true;
    this.idBeneficio = index;
  }

  abrirPopupLocaisDisponiveis(exibir: boolean) {
    this.modalLocalizacao = exibir;
  }
}
